import '../index.css';

function GitHub({ className }) {
    return (
        <svg className={className} width="42.607mm" height="41.555mm" version="1.1" viewBox="0 0 42.607 41.555" xmlns="http://www.w3.org/2000/svg" xmlnscc="http://creativecommons.org/ns#" xmlnsdc="http://purl.org/dc/elements/1.1/" xmlnsrdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">
 <title>GitHub Logo</title>
 <metadata>
  <rdfRDF>
   <ccWork rdfabout="">
    <dcFormat>image/svg+xml</dcFormat>
    <dcType rdfresource="http://purl.org/dc/dcmitype/StillImage"/>
    <dcTitle>GitHub Logo</dcTitle>
   </ccWork>
  </rdfRDF>
 </metadata>
 <g>
   <circle r="21.3035" cx="50%" cy="50%"fill="#231f20"/>
 </g>
 <g transform="translate(-.34529 -.33678)">
  <g transform="matrix(.35278 0 0 -.35278 21.649 .33678)">
   <path d="m0 0c-33.347 0-60.388-27.035-60.388-60.388 0-26.68 17.303-49.316 41.297-57.301 3.018-0.559 4.126 1.31 4.126 2.905 0 1.439-0.056 6.197-0.082 11.243-16.8-3.653-20.345 7.125-20.345 7.125-2.747 6.979-6.705 8.836-6.705 8.836-5.479 3.748 0.413 3.671 0.413 3.671 6.064-0.426 9.257-6.224 9.257-6.224 5.386-9.231 14.127-6.562 17.573-5.019 0.543 3.902 2.107 6.567 3.834 8.075-13.413 1.526-27.513 6.705-27.513 29.844 0 6.592 2.359 11.979 6.222 16.208-0.627 1.522-2.694 7.664 0.586 15.982 0 0 5.071 1.622 16.61-6.191 4.817 1.338 9.983 2.009 15.115 2.033 5.132-0.024 10.302-0.695 15.128-2.033 11.526 7.813 16.59 6.191 16.59 6.191 3.287-8.318 1.22-14.46 0.593-15.982 3.872-4.229 6.214-9.616 6.214-16.208 0-23.195-14.127-28.301-27.574-29.796 2.166-1.874 4.096-5.549 4.096-11.183 0-8.08-0.069-14.583-0.069-16.572 0-1.608 1.086-3.491 4.147-2.898 23.982 7.994 41.263 30.622 41.263 57.294 0 33.353-27.037 60.388-60.388 60.388" fill="#fff" fillRule="evenodd"/>
   
  </g>
 </g>
</svg>

    )
}

export default GitHub;